import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBin2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "bin-2_icon",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M19.5 8.99h-15a.5.5 0 0 0-.5.5v12.5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9.49a.5.5 0 0 0-.5-.5m-9.25 11.5a.75.75 0 0 1-1.5 0v-8.625a.75.75 0 0 1 1.5 0Zm5 0a.75.75 0 0 1-1.5 0v-8.625a.75.75 0 0 1 1.5 0Z" }), /* @__PURE__ */ _jsx("path", { d: "M20.922 4.851A11.8 11.8 0 0 0 16.8 3.78a4.945 4.945 0 0 0-9.607 0 12.2 12.2 0 0 0-4.012 1.025A1.94 1.94 0 0 0 2 6.476 1 1 0 0 0 3 7.49h18a1 1 0 0 0 1-.985 1.87 1.87 0 0 0-1.078-1.654M11.977 2.01A2.88 2.88 0 0 1 14.6 3.579a45 45 0 0 0-5.2 0 2.83 2.83 0 0 1 2.577-1.569" })]
});
export { SvgBin2 as ReactComponent };
